export enum PeerActions {
  MESSAGE = 'MESSAGE',
}
